import React from 'react';
import utils from '../../utils/utils.functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTrash,
  faFileInvoice,
} from '@fortawesome/free-solid-svg-icons';
import pad from 'pad';
import moment from 'moment';
import AjusteBoletaModal from './ajuste_modal/ajuste.modal';
import DetalleBoleta from './detalle_boleta/detalleboleta.modal';

const customStyles = {
    rows: {
      style: {
        minHeight: '72px', // override the row height
      }
    },
    headCells: {
      style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '8px',
      },
    },
    cells: {
      style: {
        paddingLeft: '8px', // override the cell padding for data cells
        paddingRight: '8px',
      },
    },
  };


  const conditionalRowBoleta = [
    {
      when: row => row.estado === 0,
      style: {
        backgroundColor: 'rgba(255, 127, 127, 0.9)',
        color: 'black',
        '&:hover': {
          cursor: 'pointer',
        },
      },
    },
  ];

  const pagos = () => {
    return [
      {
        name: 'Monto',
        selector: 'monto',
        sortable: true,
        cell: row => (
          `$${utils.formatMoney(row.monto, 0)}`
        )
      },
      {
        name: 'Referencia',
        selector: 'referencia',
        sortable: true,
      },
      {
        name: 'Tipo',
        selector: row => row.boleta_pagos_tipo.description,
        sortable: true,
      },
    ]
  }

  const formatAmountDocument = (type, amount, state) => {
    const getSimbol = state ? '+' : '-';
    switch(type) {
      case 'ND':
        return `${getSimbol} $${utils.formatMoney(amount, 0)}`;
      case 'NC':
        return `${getSimbol} $${utils.formatMoney(amount, 0)}`;
    }
  }

  const documentsReferences = () => {
    return [
      {
        name: 'Ref.',
        selector: row => row.reference_sale.id,
        sortable: true,
      },
      {
        name: 'Tipo documento',
        selector: row => row.reference_sale.type_document,
        sortable: true,
      },
      {
        name: 'Fecha',
        selector: row => moment(row.reference_sale.fecha).add(1, 'days').format('DD/MM/YYYY'),
        sortable: true,
      },
      {
        name: 'Monto',
        selector: row => row.reference_sale.monto_total,
        sortable: true,
        cell: row => (
          formatAmountDocument(
            row.reference_sale.type_document,
            row.reference_sale.monto_total,
            row.reference_sale.estado
          )
        )
      },
      {
        name: '',
        sortable: true,
        right: true,
        cell: row => (
          row.reference_sale.estado ? '' : <span className="badge badge-danger">ANULADO</span>
        )
      },
    ]
  }

  const productos = () => {
    return [
      {
        name: 'Cantidad',
        selector: 'cantidad',
        sortable: true,
        width: '10%',
      },
      {
        name: 'Producto',
        selector: row => row.producto.nombre_producto,
        sortable: true,
        cell: row => (
          `${row.producto.nombre_producto} ${row.observacion}`
        )
      },
      {
        name: 'Precio venta',
        selector: 'precio_modificado',
        sortable: true,
        cell: row => (
          `$${utils.formatMoney(row.precio_modificado, 0, '.')}`
        )
      },
      {
        name: 'Total',
        grow: true,
        right: true,
        cell: row => (
          `$${utils.formatMoney(row.precio_modificado * row.cantidad, )}`
        )
      },
    ]
  }


  const calculatePaymentWithDocument = (invoice) => {
    if (invoice.type_document !== 'VN') {
      return utils.formatMoney(invoice.monto_total || 0)
    } else {
      let invoiceAmount = parseInt(invoice.monto_total);
      let totalAmountDocument = invoice.documents_sales.reduce((accum,item) => {
        if (item.reference_sale.estado) {
          return accum + parseInt(item.reference_sale.monto_total);
        }
      }, 0);

      return utils.formatMoney(invoiceAmount + (totalAmountDocument || 0), 0, '.')
    }
  }

  const boletas = (updateBol, prefijoConfig) => {
    return [
      {
        name: 'Recibo',
        selector: 'id',
        sortable: true,
        width: '10%',
        cell: row => (
          pad(4,row.id,'0')
        )
      },
      {
        name: 'Cliente',
        selector: row => row.boleta_cliente.name,
        sortable: true,
        wrap: true,
        cell: row => {
          return <div className="d-flex flex-column" style={{ lineHeight: 1 }}>
            <div>{row.boleta_cliente.rut}</div>
            <div style={{ fontWeight: 'bold', fontSize: 12 }}>
              {row.boleta_cliente.name.toUpperCase()}
            </div>
          </div>
        }
      },
      {
        name: 'Monto',
        selector: 'monto_total',
        sortable: true,
        cell: row => (
          calculatePaymentWithDocument(row)
        )
      },
      {
        name: 'Estado',
        selector: 'estado',
        sortable: true,
        cell: row => {
          return row.estado ? <span className="badge badge-success">PAGADO</span> : <span className="badge badge-danger">ANULADO</span>
        }
      },
      {
        name: 'Gestor',
        selector: row => row.boleta_gestor.username,
      },
      {
        name: 'Fecha',
        selector: 'fecha',
        sortable: true,
        cell: row => {
          return moment(row.fecha).add(1, 'days').format('DD/MM/YYYY')
        }
      },
      {
        name: 'Tipo de Venta',
        selector: row => row.boleta_guia,
        cell: row => (
          <>
           {row.documents_sales.length ?
            <FontAwesomeIcon icon={faFileInvoice} className="mr-2" />
            : null
           }
            <span className="badge badge-primary w-100">
            { row.type_document === 'VN' || row.type_document === null ? 
                row.boleta_guia ? 
                  `GUIA ${row.boleta_guia.prefijo_guia || prefijoConfig}-${row.boleta_guia.guia_paquete}`
                : 
                  `VENTA PRODUCTOS`
              : row.type_document === 'ND' ? 'NOTA DE DÉBITO' : 'NOTA DE CRÉDITO'
            }
            </span>
          </>
        )
      },
      {
        name: 'Detalle',
        grow: true,
        right: true,
        cell: row => {
          return <>
            <DetalleBoleta boletaId={row.id} updateBol={(boletaId) => updateBol(boletaId)} isRefresh={true} />
            <AjusteBoletaModal boletaId={row.id} estado={row.estado}/>
          </>
        }
      }
    ]
  }

  const columns = (changePriceColumn, productsInputs, removeItems) => {
    return [
      {
        name: '',
        width: '50px',
        grow: 0,
        cell: row => {
          return row.remove ? 
                  <div onClick={() => removeItems(row)} className={{ cursor: 'pointer' }}>
                    <FontAwesomeIcon icon={faTrash} color={'red'} />
                  </div> : null;
        }
      },
      {
        name: 'Cantidad',
        selector: 'cantidad',
        sortable: true,
        width: '10%',
      },
      {
        name: 'Descripción',
        selector: 'descripcion_productos',
        sortable: true,
      },
      {
        name: 'Precio Unitario',
        selector: 'precio',
        right: true,
        sortable: true,
        cell: row => {
            return <div className="m-1">
                <input
                  ref={(el) => productsInputs.current[row.id] = el}
                  type="text"
                  className="form-control"
                  defaultValue={row.precio}
                  onBlur={(event) => changePriceColumn(event, row)}
                  onKeyPress={(event) => changePriceColumn(event, row)}
                  style={{ textAlign: 'right' }}
                />
            </div>
        }
      },
      {
        name: 'Sub Total',
        selector: 'subtotal',
        right: true,
        sortable: true,
        cell: (row) => {
          const subtotal = isNaN(row.subtotal) ? 0 : row.subtotal;
          return <div>
              ${utils.formatMoney(subtotal)}
          </div>
        }
      },
    ];
  }


const table = {
    customStyles,
    columns,
    boletas,
    conditionalRowBoleta,
    productos,
    pagos,
    documentsReferences,
    calculatePaymentWithDocument,
  }
  
  export default table;